import type { GeneratedFile, GeneratedFilesParams, GeneratedFilesResponse } from "../types/generatedFile";
import { ApiService } from "./ApiService";

export class GeneratedFileService extends ApiService {
  static pathName = "/generated-files";

  static getAll = (
    params?: GeneratedFilesParams,
  ): Promise<GeneratedFilesResponse> => {
    const queryParams: Record<string, string | number> = {};
    if (params?.spaceId) queryParams.spaceId = params.spaceId;
    if (params?.page) queryParams.page = params.page;
    if (params?.limit) queryParams.limit = params.limit;

    return ApiService.get(this.pathName, undefined, undefined, queryParams);
  };

  static getOne = (id: string): Promise<GeneratedFile> => {
    return ApiService.get(`${this.pathName}/${id}`);
  };

  static rename = (id: string, name: string): Promise<GeneratedFile> => {
    return ApiService.patch(`${this.pathName}/${id}`, { name });
  };

  static remove = (id: string) => {
    return ApiService.delete(`${this.pathName}/${id}`);
  };
}
